// PetarLubardaBiography.tsx
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  color: dimgray;
  font-family: "Arial", sans-serif;
  line-height: 1.6;
  font-size: 14px;

  @media (max-width: 768px) {
    padding-top: 60px; /* dodatni prostor za fiksiran img */
  }
`;

const Bold = styled.b``;
const Italic = styled.i``;

const Paragraph = styled.p`
  margin: 12px 0;
`;

const PetarLubarda: React.FC = () => {
  return (
    <Wrapper>
      <Paragraph>
        <Bold>PETAR LUBARDA </Bold>je rođen 1907. u Ljubotinju nedaleko od
        Cetinja, od oca Đura I. Lubarde, oficira crnogorske vojske, a potom
        potpukovnika Vojske Kraljevine Jugoslavije, i majke Marije M. Vujović,
        domaćice. Imao je petoro braće i sestara.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Školovanje 1914–1926</Bold>
        <br />
        Osnovnu školu započinje u Ljubotinju a nastavlja na Cetinju i u Herceg
        Novom. Zbog očevih oficirskih obaveza, često se sa porodicom preseljava.
        Gimnazijsko školovanje započinje u Herceg Novom i nastavlja u Splitu,
        Sinju i Nikšiću, gde stiče prva saznanja o slikarstvu kao profesiji. U
        Nikšiću, kao đak završnog razreda gimnazije, 1925. priređuje prvu
        samostalnu izložbu. Iste godine se upisuje na{" "}
        <Italic>Umetničku školu</Italic> u Beogradu, gde su mu profesori bili
        Ilija Šobajić, Ljuba Ivanović i Beta Vukanović. Međutim, nakon nekoliko
        meseci prekida školovanje i 1926. odlazi u Pariz.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Pariz 1926–1932</Bold>
        <br />U Parizu se upisuje na <Italic>Académie des Beaux Arts</Italic>,
        ali zbog loše finansijske situacije i nezadovoljstva, odustaje. Obilazi
        muzeje i galerije, radi samostalno u jeftinim otvorenim ateljeima. Na
        njega više utiču klasični majstori (Rembrant, Ticijan, El Greko) nego
        savremena strujanja. Izlaže na{" "}
        <Italic>Salonu nezavisnih (Salon des Indépendants)</Italic> 1927. Sa
        grupom srpskih umetnika koji žive u Parizu izlaže 1928. u Slavističkom
        institutu u Parizu. Prvi put samostalno izlaže u Rimu 1929. u{" "}
        <Italic>Casa dell’ Arte Bragaglia</Italic>. Prvi susret sa
        srednjovekovnim fresko-slikarstvom doživeo je u Parizu kada je u izlogu
        jedne knjižare video otvorenu knjigu sa reprodukcijom „Pokolja
        Vitlejemske dece” iz Markovog manastira u okolini Skoplja.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Slike:</Bold>
        <br />
        <Bold>Pejzaž s fenjerom</Bold> (1927), <Bold>Crveni pejzaž</Bold>{" "}
        (1927), <Bold>Za stolom</Bold> (1927), <Bold>Ciganka [Crnogorka]</Bold>{" "}
        (1928), <Bold>Naga žena</Bold> (1928), <Bold>Motiv sa Marne</Bold>{" "}
        (1931)
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Povratak 1932–1938</Bold>
        <br />
        Vraća se u Jugoslaviju 1932. gde živi u Beogradu, ali često boravi u
        Crnoj Gori i u Dalmaciji. Već od sledeće godine redovno izlaže na
        „Prolećnim izložbama slikarskih i vajarskih radova jugoslovenskih
        umetnika”, a od 1935. i na „Jesenjim izložbama slikarskih i vajarskih
        radova beogradskih umetnika” u{" "}
        <Italic>Umetničkom paviljonu „Cvijeta Zuzorić”</Italic>. Prvu samostalnu
        izložbu priredio je 1933. godine u Beogradu u{" "}
        <Italic>Francusko-srpskom klubu</Italic>. Samostalno izlaže 1934. i
        1937. u <Italic>Umetničkom paviljonu</Italic>. Ovu drugu izložbu otvorio
        je Milan Kašanin, upravnik <Italic>Muzeja kneza Pavla</Italic>. Izlaže u{" "}
        <Italic>Jugoslovenskom paviljonu</Italic> na Svetskoj izložbi u Parizu
        1937. i dobija <Italic>Grand Prix</Italic>. Postaje član Društva srpskih
        umetnika „Lada” 1938. sa kojim od tada redovno izlaže.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Slike:</Bold>
        <br />
        <Bold>Portret crnogorca</Bold> (1933), <Bold>Majka sa detetom</Bold>{" "}
        (1934), <Bold>Prodavac pomorandži</Bold> (1936),{" "}
        <Bold>Glava seljaka</Bold> (1937), <Bold>Nosač</Bold> (1937),{" "}
        <Bold>Šiptar</Bold> (1936), <Bold>Pogreb [Motiv iz Crne Gore]</Bold>{" "}
        (1933), <Bold>Motiv iz Crnogorskog primorja</Bold> (1933),{" "}
        <Bold>Dubrovnik</Bold> (1935), <Bold>Predeo iz Rume</Bold> (1937),{" "}
        <Bold>Gruda</Bold> (1933), <Bold>Stari Bar</Bold> (1936),{" "}
        <Bold>Rijeka Crnojevića</Bold> (1937),{" "}
        <Bold>Bombardovanje San Sebastijana</Bold> (1937), <Bold>More</Bold>{" "}
        (1938), <Bold>Pejzaž s crkvom</Bold> (1938), <Bold>Virpazar</Bold>{" "}
        (1937)
      </Paragraph>
      <Paragraph>
        <Bold style={{ color: "#414141" }}>Pariz 1938–1940</Bold>
        <br />
        Odlazi u Pariz gde ostaje do 1940. Putuje po Španiji, Nemačkoj, Tunisu,
        Alžiru i Egiptu. Muzej <Italic>Jeu de Paume</Italic> u Parizu otkupljuje
        sliku <Bold>Žabljak na Skadarskom jezeru</Bold> 1938. Slika se danas
        nalazi u <Italic>Fonds national d’art contemporain</Italic>, pri Centru
        „Žorž Pompidu” u Parizu. Sledeće godine dobija prvu nagradu na
        internacionalnoj izložbi slikarstva u Hagu.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Slike:</Bold>
        <br />
        <Bold>Maslina</Bold> (1938), <Bold>Enterijer</Bold> (1938),{" "}
        <Bold>Vaza</Bold> (1939), <Bold>Primorje – Zaliv</Bold> (1940),{" "}
        <Bold>Isentemba</Bold> (1939), <Bold>Zaklano jagnje</Bold> (1940),{" "}
        <Bold>Fazan</Bold> (1940), <Bold>Mrtva priroda sa belom činijom</Bold>{" "}
        (1940), <Bold>Mrtva priroda sa armaturom</Bold> (1941)
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Zarobljeništvo 1941–1944</Bold>
        <br />
        Rat provodi kao ratni zarobljenik u logorima u Nemačkoj i Italiji. Sve
        vreme crta i slika.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Crteži:</Bold>
        <br />
        <Bold>Zarobljenik</Bold> (1941), <Bold>Glava</Bold> (1941),{" "}
        <Bold>Šinjel</Bold> (1943), <Bold>Iz logora – skica</Bold> (1943),{" "}
        <Bold>Čitanje pisma u logoru</Bold> (1943),{" "}
        <Bold>Zarobljenik iz nemačkog logora</Bold> (1943),{" "}
        <Bold>Logor u Italiji</Bold> (1943)
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Slike:</Bold>
        <br />
        <Bold>Glava zarobljenika</Bold> (1942),{" "}
        <Bold>Zarobljenik čita novine</Bold> (1942),{" "}
        <Bold>Stalag – Drugovi</Bold> (1942), <Bold>Logor</Bold> (1942),{" "}
        <Bold>Kroz prozor</Bold> (1942), <Bold>Motiv iz logora</Bold> (1942),{" "}
        <Bold>Predvečerje u logoru</Bold> (1943), <Bold>Kutak zida</Bold>{" "}
        (1943), <Bold>Iz logorske barake</Bold> (1943), <Bold>U baraci</Bold>{" "}
        (1943)
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Posleratne godine 1945–1949</Bold>
        <br />
        Živi u Beogradu. Oca Đuru streljaju nove komunističke vlasti. Ženi se
        Verom Protić, studentkinjom <Italic>Likovne akademije</Italic> u
        Beogradu. Učestvuje na izložbama{" "}
        <Italic>Udruženja likovnih umetnika Srbije</Italic>. Radi kao profesor
        na <Italic>Likovnoj akademiji</Italic> do 1946. kada ga, kao navodnog
        predstavnika „formalističke škole”, zajedno sa Milom Milunovićem
        premeštaju na službu na Cetinje. Učestvuje u formiranju i na prvoj
        izložbi <Italic>Udruženja likovnih umetnika Crne Gore</Italic>. Postaje
        drugi predsednik ULUCG-a. Učestvuje u formiranju{" "}
        <Italic>Umetničke škole</Italic> na Cetinju 1947. Bio je njen profesor i
        prvi direktor. Boravkom na Cetinju, u ponovnom susretu sa prirodom,
        Lubarda pravi istorijski zaokret ka uspostavljanju jedne sasvim
        originalne modernističke koncepcije slike. Ovde nastaju neka njegova
        kapitalna dela, koja će kasnije biti izložena na istorijskoj izložbi u
        Umetničkoj galeriji ULUS-a. Tokom 1948. obilazi manastire u Makedoniji i
        Srbiji.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Slike:</Bold>
        <br />
        <Bold>Patnje naroda</Bold> (1944–1945), <Bold>Juriš</Bold> (1945),{" "}
        <Bold>Žetva – vršidba</Bold> (1946),{" "}
        <Bold>Sećanje na 1941. godinu</Bold> (1947), <Bold>Vagonet</Bold>{" "}
        (1948), <Bold>Motiv iz Crmnica</Bold> (1946), <Bold>Donji kraj</Bold>{" "}
        (1947), <Bold>Predeo sa plavim brdima, Narovi</Bold> (1949),{" "}
        <Bold>Cetinje sa Lovćenom</Bold> (1949)
      </Paragraph>
      <Paragraph>
        <Bold style={{ color: "#414141" }}>Istorijska izložba 1950–1951</Bold>
        <br />
        Učestvuje na istorijskoj izložbi jugoslovenskog slikarstva od 1900. do
        1950. godine u Umetničkoj galeriji ULUS-a u Beogradu, gde su prikazane
        njegove važne slike iz perioda 1935–1949. Izložba je bila povod za
        značajniji umetnički dijalog i priznavanje njegove umetničke ličnosti.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Slike iz tog perioda:</Bold>
        <br />
        <Bold>Primorje – Zaliv</Bold> (1949), <Bold>Motiv sa Lovćena</Bold>{" "}
        (1950), <Bold>Rudnik</Bold> (1950), <Bold>Predeo sa livadom</Bold>{" "}
        (1951)
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Kasnije godine i priznanja</Bold>
        <br />
        Nakon 1950. godine Lubarda intenzivno radi i učestvuje na brojnim
        domaćim i međunarodnim izložbama. Dobija mnoge nagrade i priznanja.
        Predaje kao profesor i redovni član SANU (Srpske akademije nauka i
        umetnosti). Njegova umetnička ostavština ostaje trajni pečat u istoriji
        jugoslovenskog i srpskog slikarstva.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>Nagrade i priznanja:</Bold>
        <br />
        <Bold>Nagrada Oktobarskog salona</Bold> (1952),{" "}
        <Bold>Nagrada na Bijenalu u Veneciji</Bold> (1956),{" "}
        <Bold>Nagrada grada Beograda</Bold> (1965),{" "}
        <Bold>Nagrada za životno delo</Bold> (1972)
      </Paragraph>
      <div style={{ height: "50px" }} />
    </Wrapper>
  );
};

export default PetarLubarda;
